import { useState } from 'react';
import { useViewChannels } from 'src/hooks';
import { useGetAllLayoutType } from 'src/hooks/api/layoutTypes/useGetAllLayoutTypes';

export const useAddNewLocationGroup = () => {
  const [selectedLayoutTypeState, setSelectedLayoutTypeState] = useState(-1);

  const {
    data: layoutTypes = [],
    isLoading: isLoadinglayoutTypes,
    error: errorLoadinglayoutTypes,
  } = useGetAllLayoutType();

  const {
    data: channels = [],
    isLoading: isLoadingChannels,
    error: errorLoadingChannels,
  } = useViewChannels();

  const filteredChannels = channels
    ? channels.filter((channel) =>
        channel.layout_type_id.includes(selectedLayoutTypeState),
      )
    : [];

  return {
    isLoadinglayoutTypes,
    isLoadingChannels,
    errorLoadinglayoutTypes,
    errorLoadingChannels,
    layoutTypes,
    channelsData: filteredChannels,
    setSelectedLayoutTypeState,
    selectedLayoutTypeState,
  };
};
